import { IComponentGameObject } from "../../interfaces/IComponentGameObject";
import { ScreenManager, ScreenManagerEvents, ScreenTransitionDirection } from "../../managers/ScreenManager";
import ComponentService from "../../services/ComponentService";
import { TableStackInit } from "../cardStack/TableStackInit";
import { DealerTableToPlayer } from "../components/DealerTableToPlayer";
import { LoaderFileKeys } from "../constant/AppConstants";
import { Players } from "../player/Players";
import { TablePhase, TableStateMachine, TrumpSuit } from "../state/TableStateMachine";
import { DealerPlayerToTable } from "../components/DealerPlayerToTable";
import { PopupBiddingChooseSuit, PopupChooseSuitLayoutType } from "../popup/PopupBiddingChooseSuit";
import { TableStateMachineBelote } from "../state/TableStateMachineBelote";
import { PopupBiddingTakeSuit } from "../popup/PopupBiddingTakeSuit";
import { TableAI } from "../ai/TableAI";
import { CardsManager } from "../managers/CardsManager";
import { Card } from "../card/Card";
import { CardPlayer } from "../components/CardPlayer";
import { TableStackPlay } from "../cardStack/TableStackPlay";
import { TrickCollector } from "../components/TrickCollector";
import { SelectedTrumpView, SelectedTrumpViewLayout } from "../views/SelectedTrumpView";
import { TableScore, TableScoreLayout } from "../views/TableScore";
import { LastTrickView } from "../views/LastTrickView";
import { ScreenOrientationType } from "../../utils/GetOrientation";
import { CardPointsView } from "../views/CardPointsView";
import { AppSettings } from "../managers/AppSettings";
import { DeclarationsManager } from "../ai/DeclarationsManager";
import { IconButton } from "../../ui/IconButton";
import { RectSize } from "../../utils/RectSize";
import GameScene from "../../scenes/GameScene";
import { DealerChipController } from "../views/DealChipController";
import { OptionsDataManager } from "../managers/OptionsDataManager";
import { AppLocalStorage } from "../managers/AppLocalStorage";
import { LayoutDataManager, OptionsItemKeys } from "../managers/LayoutDataManager";
import { TableStateMachineContree } from "../state/TableStateMachineContree";
import { TableStateMachineCoinche } from "../state/TableStateMachineCoinche";
import { PopupBiddingContra } from "../popup/PopupBiddingContra";
import { LobbyHeaderProps, OptionsItemLiveData, TableData } from "../../types/types";
import { Player } from "../player/Player";
import { ToggleButton } from "../../ui/ToggleButton";
import { PopupHint } from "../popup/PopupHint";
import { ButtonEvents } from "../../ui/ButtonBase";
import { LanguageId } from "../localization/AppLocalization";
import { AppAudioPlayer, SoundEffectKeys } from "../../audio/AppAudioPlayer";
import { AppDebug } from "../debug/AppDebug";
import { IsIPad } from "../../utils/IsIPad";
import { PopupBinary } from "../popup/PopupBinary";
import { AppTimings } from "../data/AppConstants";


export enum VariationId {
    BELOTE = 0,
    COINCHE = 1,
    CONTREE = 2
}

export class TableScreen
    extends Phaser.GameObjects.Container
    implements IComponentGameObject {
    public components!: ComponentService;
    public cid: string;
    public players: Players;
    public tableStackInit: TableStackInit;
    public tableStackPlay: TableStackPlay;
    public cardContainer: Phaser.GameObjects.Container;
    private stateMachineByVariationId: Map<number, TableStateMachine>;
    // private tableAiByVariationId: Map<number, TableAI>;
    protected tableAI: TableAI;
    public curStateMachineIndex: number;
    public declarationsManager: DeclarationsManager;
    public popupChoiceTakeSuit: PopupBiddingTakeSuit;
    public popupChoiceChooseSuit: PopupBiddingChooseSuit;
    public popupContraBid: PopupBiddingContra;
    public popupContra: PopupBinary;
    public popupHint: PopupHint;
    public selectedTrumpView: SelectedTrumpView;
    public lastTrickView: LastTrickView;
    public cardPointsView: CardPointsView;
    public tableScore: TableScore;
    public majorDeclarationContainer: Phaser.GameObjects.Container;
    public btnLobby: IconButton;
    public btnHints: ToggleButton;
    public btnFullscreen: ToggleButton;
    public dealerChipController: DealerChipController;
    public backClickCallback: Function;
    public variationId: VariationId;
    public languageId: LanguageId;
    public transitionDirection: ScreenTransitionDirection = ScreenTransitionDirection.RIGHT_TO_CENTER;
    private isDirtyLocUpdate: boolean = true;


    public Init(backClickCallback: Function): void
    // public Init(): void
    {
        this.visible = false;

        this.backClickCallback = backClickCallback;

        // generic
        this.components = new ComponentService();

        this.stateMachineByVariationId = new Map<number, TableStateMachine>();
        this.stateMachineByVariationId.set(VariationId.BELOTE, new TableStateMachineBelote());
        this.stateMachineByVariationId.get(VariationId.BELOTE).Init(this);
        this.stateMachineByVariationId.set(VariationId.COINCHE, new TableStateMachineCoinche());
        this.stateMachineByVariationId.get(VariationId.COINCHE).Init(this);
        this.stateMachineByVariationId.set(VariationId.CONTREE, new TableStateMachineContree());
        this.stateMachineByVariationId.get(VariationId.CONTREE).Init(this);

        this.tableAI = new TableAI();
        this.tableAI.Init(this);
    }

    public Build(): void {
        // put a CLICK listener on each card
        CardsManager.GetCards().forEach(card => {
            card.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN,
                this.OnCardPointerDownHandler,
                { card: card, table: this },
            );
        });

        // create before you build players, add to display list later
        this.majorDeclarationContainer = this.scene.make.container({});

        // stack from which to deal cards to players
        this.tableStackInit = new TableStackInit(this.scene);
        this.tableStackInit.name = "tableStackInit";
        this.tableStackInit.Hide(false);
        this.add(this.tableStackInit);

        // stack to which players deal cards (max 4 cards per trick)
        this.tableStackPlay = new TableStackPlay(this.scene);
        this.tableStackPlay.name = "tableStackPlay";
        this.tableStackPlay.Hide(false);
        this.add(this.tableStackPlay);
        
        this.add(this.majorDeclarationContainer);

        this.tableScore = new TableScore(this.scene);
        this.tableScore.Init();
        this.tableScore.Build();
        this.tableScore.Hide(false);
        // this.tableScore.Show();
        this.add(this.tableScore);

        this.selectedTrumpView = new SelectedTrumpView(this.scene);
        this.selectedTrumpView.Init(this);
        this.selectedTrumpView.Build();
        this.selectedTrumpView.Hide(false);
        // this.selectedTrumpView.Show();
        this.add(this.selectedTrumpView);

        this.players = new Players();
        this.players.Init(this.scene, this);
        this.players.Build();
        this.players.Hide(false);

        this.dealerChipController = new DealerChipController(this.scene);
        this.dealerChipController.Init(this);
        this.dealerChipController.Build();
        this.dealerChipController.Hide(false);
        this.add(this.dealerChipController);
        
        this.cardContainer = new Phaser.GameObjects.Container(this.scene);
        this.add(this.cardContainer);

        // attach components to table
        this.components.AddComponent(this, new DealerTableToPlayer(this.tableStackInit));
        this.components.AddComponent(this, new DealerPlayerToTable(this.tableStackPlay));
        this.components.AddComponent(this, new CardPlayer());
        this.components.AddComponent(this, new TrickCollector(this.tableStackPlay));

        this.lastTrickView = new LastTrickView(this.scene);
        // this.lastTrickView.setScale(0.4);
        this.lastTrickView.Init();
        this.lastTrickView.Build();
        this.lastTrickView.PostBuild();
        // this.lastTrickView.SetData(); // calls UpdateView
        this.lastTrickView.Hide(false);
        // this.lastTrickView.Show();
        this.add(this.lastTrickView);

        this.cardPointsView = new CardPointsView(this.scene);
        this.cardPointsView.Init();
        this.cardPointsView.Build();
        this.cardPointsView.PostBuild();
        this.cardPointsView.Hide(false);
        this.add(this.cardPointsView);

        // declarationsManager
        this.declarationsManager = new DeclarationsManager();
        this.declarationsManager.Init(this);

        // popups
        // bidding: take suit
        this.popupChoiceTakeSuit = new PopupBiddingTakeSuit(this.scene);
        this.popupChoiceTakeSuit.name = "popupChoiceTakeSuit";
        this.popupChoiceTakeSuit.Init();
        this.popupChoiceTakeSuit.Build();
        // this.popupChoiceTakeSuit.SetData({taskType:TaskType.BID, onComplete:this.stateMachine.OnTaskComplete});
        this.popupChoiceTakeSuit.Hide(false);
        this.add(this.popupChoiceTakeSuit);

        // popups
        // bidding: choose suit
        this.popupChoiceChooseSuit = new PopupBiddingChooseSuit(this.scene);
        this.popupChoiceChooseSuit.name = "popupChoiceChooseSuit";
        this.popupChoiceChooseSuit.Init();
        this.popupChoiceChooseSuit.Build();
        this.popupChoiceChooseSuit.SetLayoutType(PopupChooseSuitLayoutType.NO_NT_AT);
        // debug
        // this.popupChoiceChooseSuit.SetData({
        //     taskType: TaskTypeBelote.CHOICE_SELECT_SUIT, 
        //     onComplete: ()=> { console.log("test done."); },
        //     disabledChoices: [
        //         // PopupBiddingChoiceType.NOTRUMPS,
        //         // PopupBiddingChoiceType.ALLTRUMPS,
        //         PopupBiddingChoiceType.SUIT_SPADES
        //     ]
        // });
        this.popupChoiceChooseSuit.Hide(false);
        // this.popupChoiceChooseSuit.Show(false);
        this.add(this.popupChoiceChooseSuit);

        // bidding: make bid (coinche, contree?)
        this.popupContraBid = new PopupBiddingContra(this.scene);
        this.popupContraBid.name = "popupChoiceChooseSuit";
        this.popupContraBid.Init();
        this.popupContraBid.Build();
        // this.popupContraBid.SetLayoutType(?);
        // debug
        // this.popupContraBid.SetData({
        //     taskType: TaskTypeBelote.CHOICE_SELECT_SUIT, 
        //     onComplete: ()=> { console.log("test done."); },
        //     disabledChoices: [
        //         // PopupBiddingChoiceType.NOTRUMPS,
        //         // PopupBiddingChoiceType.ALLTRUMPS,
        //         PopupBiddingChoiceType.SUIT_SPADES
        //     ]
        // });
        this.popupContraBid.Hide(false);
        // this.popupContraBid.Show(false);
        this.add(this.popupContraBid);

        // 
        this.popupContra = new PopupBinary(this.scene);
        // this.popupContra.name = "popupContra";
        this.popupContra.Init();
        this.popupContra.Build();
        // debug
        // this.popupContra.SetData({
        //     taskType: TaskTypeBelote.CHOICE_SELECT_SUIT, 
        //     onComplete: ()=> { console.log("test done."); },
        // });
        this.popupContra.Hide(false);
        this.add(this.popupContra);

        this.popupHint = new PopupHint(this.scene);
        this.popupHint.Init(this);
        this.popupHint.Build();
        this.popupHint.bubble.SetFacingGrowingUp(false);
        this.popupHint.Hide(false);
        this.add(this.popupHint);

        // btnLobby (before/under popupGameComplete)
        this.btnLobby = new IconButton(this.scene);
        this.btnLobby.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-round-bg-out.png" },
            over: { texture: LoaderFileKeys.ui, frame: "btn-round-bg-over.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-round-bg-disabled.png" },
        }
        );
        this.btnLobby.InitIcon({
            out: { texture: LoaderFileKeys.ui, frame: "icon-back-black.png" }
        });
        this.btnLobby.PostInit(40);
        // shadow
        const btnLobbyShadow = this.scene.make.image({ key: LoaderFileKeys.ui, frame: "circle-01-shadow.png" }).setScale(1.15);
        this.btnLobby.add(btnLobbyShadow);
        this.btnLobby.sendToBack(btnLobbyShadow);
        this.add(this.btnLobby);

        this.btnHints = new ToggleButton(this.scene);
        // this.btnHints.name = "btnHints-TableScene";
        this.btnHints.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-hints-off-out.png" },
            over: { texture: LoaderFileKeys.ui, frame: "btn-hints-off-over.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-hints-off-disabled.png" },
        },
            false, // isInteractive?
        );
        this.btnHints.InitToggle({
            out: { texture: LoaderFileKeys.ui, frame: "btn-hints-on-out.png" },
            over: { texture: LoaderFileKeys.ui, frame: "btn-hints-on-over.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-hints-on-disabled.png" },
        },
            false, // isSelected?
        );
        this.btnHints.PostInit(40);
        // shadow
        const btnHintsShadow = this.scene.make.image({ key: LoaderFileKeys.ui, frame: "circle-01-shadow.png" }).setScale(1.15);
        this.btnHints.add(btnHintsShadow);
        this.btnHints.sendToBack(btnHintsShadow);
        this.add(this.btnHints);

        // fullscreen toggle button
        const isFullscreenSupported: boolean = this.scene.scale.fullscreen.available && !AppDebug.HasForceHideFullscreenBtn();
        if (isFullscreenSupported) {
            const isFullScreen: boolean = this.scene.scale.isFullscreen;
            // NOTE: fs always initially OFF. Need user click to ON.
            this.btnFullscreen = new ToggleButton(this.scene);
            this.btnFullscreen.InitBase({
                out: { texture: LoaderFileKeys.ui, frame: "btn-fs-on-out.png" },
                over: { texture: LoaderFileKeys.ui, frame: "btn-fs-on-over.png" }
            }, true);
            this.btnFullscreen.InitToggle({
                out: { texture: LoaderFileKeys.ui, frame: "btn-fs-on-off-out.png" },
                over: { texture: LoaderFileKeys.ui, frame: "btn-fs-on-off-over.png" }
            }, isFullScreen);
            this.btnFullscreen.PostInit(30);
            // this.btnFullscreen.setScale(0.85);
            this.add(this.btnFullscreen);
        }
    }

    public GetTableAI(): TableAI {
        // return this.tableAiByVariationId.get(this.variationId);
        return this.tableAI;
    }

    public GetStateMachine(): TableStateMachine {
        return this.stateMachineByVariationId.get(this.variationId);
    }

    public SetVariationId(variationId: VariationId): void {
        if (this.variationId != variationId) {
            this.variationId = variationId;
            this.isDirtyLocUpdate = true;
        }
    }

    public SetLanguageId(languageId: LanguageId): void {
        if (this.languageId != languageId) {
            this.languageId = languageId;
            this.isDirtyLocUpdate = true;
        }
    }

    /**
     * Starts table from variation data
     * - for specific variation 
     * - from cached data or new data (detected automatically)
     * 
     * NOTE: to ensure there is 'cached data' or 'no cached data',
     *       handle this in parent (delete cached data if exists and 
     *       you need a new game)
     * NOTE: nextDeal is not part of table start, 
     *       rather it is a loop withing existing model
     */
    public Start(enteredFromLobby: boolean): void {
        // load existing table data or null if not exist
        let tableData: TableData = AppLocalStorage.GetTableData(this.variationId);

        // reset table (pool cards, etc)
        // this.Reset();

        // if no table data for this variation
        if (tableData == null) {
            // create new data
            this.GetStateMachine().GetSetDataNewGame(this.variationId);
        }
        else {
            // else set cached data
            this.GetStateMachine().SetData(tableData);
        }

        // update views with new data
        this.GetStateMachine().UpdateViewFromData();

        this.GetStateMachine().Start(tableData != null, enteredFromLobby);
    }

    public Show(animated: boolean = true, onComplete?: Function, ease: Function = undefined): void {
        // update view from loc change if dirty
        // console.log("this.isDirtyLocUpdate", this.isDirtyLocUpdate);
        // console.log("this.variationId", VariationId[this.variationId]);
        // console.log("this.languageId", LanguageId[this.languageId]);
        if (this.isDirtyLocUpdate) {
            this.isDirtyLocUpdate = false;
            this.UpdateViewFromLocalizationChange();
        }

        if (ease == undefined) {
            ease = AppSettings.ease.screenShowHideEase;
        }

        // show children based on data
        this.OnShowStart(false, true);
        // show screen
        this.scene.tweens.killTweensOf(this);
        const scrTransData = ScreenManager.GetScreenTransitionPositions(this.transitionDirection);
        this.visible = true;
        let duration: number = OptionsDataManager.GetTiming(AppTimings.screenShowDuration);
        if (animated) {
            this.x = scrTransData.startX;
            this.scene.tweens.add({
                targets: this,
                x: scrTransData.endX,
                duration: duration,
                ease: ease,
                onComplete: () => onComplete?.(),
            });
        }
        else {
            this.x = scrTransData.endX;
            onComplete?.();
        }
    }

    /**
     * Internal restart of table occurs via stateMachine, as result of:
     * - all players PASS 2 times (exception: Options toggle: TODO)
     * - NEW GAME via @see PopupGameComplete
     * - CONTINUE via @see DealCompleteScreen
     * 
     * @param internalRestart 
     *  true: one of the above use-cases;
     *  false: NEW GAME from Lobby or CONTINUE from Lobby;
     */
    public OnShowStart(
        animated: boolean = false,
        registerListeners: boolean = true,
    ): void {
        // console.log("OnShowStart");

        const tableData: TableData = this.GetStateMachine().GetData();

        // play stack
        if (!this.tableStackPlay.IsShowing()) {
            this.tableStackPlay.Show(animated);
        }

        // init stack
        if (!this.tableStackInit.IsShowing()) {
            this.tableStackInit.Show(animated);
        }

        // players
        if (!this.players.IsShowing()) {
            this.players.Show(animated);
        }
        // tableScore
        const showScores = OptionsDataManager.GetItemDataByItemId(OptionsItemKeys.showScores, this.variationId);
        const isShowScores = showScores && (showScores.value as boolean);
        if (isShowScores) {
            if (!this.tableScore.IsShowing()) {
                this.tableScore.Show(animated);
            }
        }

        // trumpSuit check would work for Belote, but not for Coinche/Contree
        if (tableData.trumpSuit != TrumpSuit.UNDEFINED) {
            if (this.GetStateMachine().GetTablePhase() == TablePhase.PLAY) {
                if (!this.selectedTrumpView.IsShowing()) {
                    this.selectedTrumpView.Show(animated);
                }
                if (!this.cardPointsView.IsShowing()) {
                    this.cardPointsView.Show(animated);
                }
            }
        }

        // lastTrickView
        if (tableData.historyTricksData.length) {
            if (!this.lastTrickView.IsShowing()) {
                this.lastTrickView.Show(animated);
            }
        }

        // chip
        if (!this.dealerChipController.IsShowing()) {
            this.dealerChipController.Show(animated);
        }

        // now resize everything and enable events inside this screen
        this.OnResizeManual();
        this.OnOrientationChangedManual();

        // console.trace("registerListeners?",registerListeners)
        // if starting table afresh (OnShowStart triggered via this.Show);
        if (registerListeners) {
            // register table listeners
            this.RegisterListeners();
            // NOTE: to set index to snap to, 
            //      use this.dealerChipController.SetDealerIndex before calling this.Start()
            this.dealerChipController.SnapToPlayer();
        }
    }

    public Hide(animated: boolean = true, onComplete: Function = undefined, ease: Function = undefined): void {
        // console.log("Hide", animated);

        if (ease == undefined) {
            ease = AppSettings.ease.screenShowHideEase;
        }

        // show children based on data
        this.OnHideStart(animated);

        // hide screen
        this.scene.tweens.killTweensOf(this);
        const scrTransData = ScreenManager.GetScreenTransitionPositions(this.transitionDirection);
        let duration: number = OptionsDataManager.GetTiming(AppTimings.screenHideDuration);
        if (animated) {
            this.x = scrTransData.startX;
            this.scene.tweens.add({
                targets: this,
                x: scrTransData.endX,
                duration: duration,
                ease: ease,
                onComplete: () => {
                    this.visible = false;
                    onComplete?.();
                },
            });
        }
        else {
            this.x = scrTransData.endX;
            this.visible = false;
            onComplete?.();
        }
    }

    protected OnHideStart(animated: boolean, onComplete: Function = undefined): void {
        // console.log("OnHideStart");
        // console.trace("OnHideStart");

        this.UnregisterListeners();
    }

    protected RegisterListeners(): void {
        // console.log("RegisterListeners");

        this.btnLobby.on(ButtonEvents.CLICK, this.OnLobbyClick, this);
        this.btnHints.on(ButtonEvents.CLICK, this.OnBtnHintsClick, this);
        if (this.btnFullscreen) this.btnFullscreen.on(ButtonEvents.CLICK, this.OnFullscreenClick, this);

        ScreenManager.GetEventEmitter().on(ScreenManagerEvents.RESIZE, this.OnResize, this);
        ScreenManager.GetEventEmitter().on(ScreenManagerEvents.ORIENTATION_CHANGE, this.OnOrientationChanged, this);

        this.dealerChipController.Registeristeners();
    }

    protected UnregisterListeners(): void {
        // console.log("UnregisterListeners");

        this.btnLobby.off(ButtonEvents.CLICK, this.OnLobbyClick);
        this.btnHints.off(ButtonEvents.CLICK, this.OnBtnHintsClick);
        if (this.btnFullscreen) this.btnFullscreen.off(ButtonEvents.CLICK, this.OnFullscreenClick);

        ScreenManager.GetEventEmitter().off(ScreenManagerEvents.RESIZE, this.OnResize);
        ScreenManager.GetEventEmitter().off(ScreenManagerEvents.ORIENTATION_CHANGE, this.OnOrientationChanged);

        this.dealerChipController.UnRegisteristeners();
    }

    public GetScene(): GameScene {
        return this.scene as GameScene;
    }

    /**
     * Hide table contents, WITHOUT animation
     * NOTE: call before stateMachine.UpdateViewFromData (@see GameScene)
     */
    public HideContent(): void {
        this.players.Hide(false);
        this.tableStackInit.Hide(false);
        this.tableStackPlay.Hide(false);
        this.tableScore.Hide(false);
        this.selectedTrumpView.Hide(false);
        this.lastTrickView.Hide(false);
        this.cardPointsView.Hide(false);
        this.popupChoiceTakeSuit.Hide(false);
        this.popupChoiceChooseSuit.Hide(false);
        this.popupContraBid.Hide(false);
        this.popupContra.Hide(false);
        this.popupHint.Hide(false);
        this.GetScene().dealCompleteScreen.Hide(false);
        this.dealerChipController.Hide(false);
    }

    /**
     * A 'more efficient' version of TableScreen::UpdateViewFromData (which runs every table show),
     * that only runs every time langId or variationId changes (on table::Show).
     * Update occurs via @see this.Show, if @see this.isDirtyLocUpdate = TRUE.
     * NOTE: at this point this.variationId and this.languageId have been assigned.
     */
    public UpdateViewFromLocalizationChange(): void {
        // console.log("UpdateViewFromLocalizationChange");

        // UPDATE NOW
        // Us / Them labels
        this.tableScore.UpdateViewFromLocalizationChange(this.languageId);
        // header
        this.lastTrickView.UpdateViewFromLocalizationChange(this.languageId);
        // header, column(s) title(s)
        this.cardPointsView.UpdateViewFromLocalizationChange(this.languageId);
        // header (bow)
        this.popupChoiceTakeSuit.UpdateViewFromLocalizationChange(this.languageId);
        // header (bow), NT/AT (if applicable), PASS
        this.popupChoiceChooseSuit.UpdateViewFromLocalizationChange(this.languageId);
        // header (bow), NT/AT (if applicable), CONTRA, PASS
        this.popupContraBid.UpdateViewFromLocalizationChange(this.languageId);

        // NOTE: player name is set via selectedTrumpView.SetPlayerIndex and saved to localStorage until new game.
        // this.selectedTrumpView.SetPlayerIndex
        // NOTE: player label is saved into localStorage and recreated on new game.
        // this.players

        // UPDATE JIT (BEFORE SHOW; REBUILDS COMPLETELY) 
        // this.GetScene().dealCompleteScreen
        // this.GetScene().popupGameComplete
        // title, primary label, secondary label
        // this.popupContra
        // body text
        // this.popupHint
    }

    private OnLobbyClick(): void {
        this.backClickCallback?.();
    }

    private OnBtnHintsClick(): void {
        // console.log("OnBtnHintsClick");
        this.btnHints.Toggle();
        const cardPlayer = this.components.GetComponent(this, CardPlayer);
        const playerIndex = this.GetStateMachine().GetData().lastPlayedPlayerIndex;
        const player: Player = this.players.GetPlayerByIndex(playerIndex);
        // NOTE: suggestedCards returns undefined during bidding phase
        const suggestedCards: Card[] = this.GetTableAI().GetSuggestedCards();
        if (this.btnHints.IsSelected()) {
            if (suggestedCards != undefined) {
                if (this.GetStateMachine().GetTablePhase() != TablePhase.BIDDING) {
                    cardPlayer.HighlightCards(suggestedCards, playerIndex);
                } 
            }
            this.popupHint.Show();
        }
        else {
            if (suggestedCards != undefined) {
                if (this.GetStateMachine().GetTablePhase() != TablePhase.BIDDING) {
                    cardPlayer.HighlightCards(player.GetCards(), playerIndex);
                }
            }
            this.popupHint.Hide();
        }
    }

    private OnFullscreenClick(): void {
        // console.log("TableScene::OnFullscreenClick");

        // toggle click
        AppAudioPlayer.PlaySfx(SoundEffectKeys.click3);

        this.scene.scale.toggleFullscreen();
    }

    private OnCardPointerDownHandler(pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) {
        // console.log("TableBase::OnCardPointerDownHandler");

        // prevent clicking other cards through this one
        event.stopPropagation();

        // get refs
        const table: TableScreen = (this as any).table as TableScreen;

        // if this was fired by LMB or Touch
        // NOTE: tested: LMB=touch, RMB = NOT A TOUCH (pointer.rightButtonDown()=false)
        // if (table.IsOnlyLeftButtonDown(pointer)) {
        if (table.IsOnlyLeftButtonDown(pointer)) {
            // get refs
            const card: Card = (this as any).card as Card;

            // console.log("clicked card",card.log());
            // this.stateMachine.OnCardClicked(card);
            const cardPlayer: CardPlayer = table.components.GetComponent(table, CardPlayer);
            cardPlayer.OnCardClicked(card, table);
        }
    }

    /**
     * - Reset components/screens/etc to default view/state
     * - Put ALL CARDS back to CardsManager (no matter where they are)
     * NOTE: This needs to execute at the edge of Table->Lobby transition
     */
    public Reset(): void {
        // put player cards back to CardsManager, reset player bubble
        this.players.Reset();
        // put stack cards back to CardsManager
        this.tableStackInit.PoolCards();
        this.tableStackPlay.PoolCards();
        // 
        this.components.GetComponent(this, DealerPlayerToTable).Reset();
        this.components.GetComponent(this, DealerTableToPlayer).Reset();

        // pool remaining 'unreferenced' cards
        CardsManager.PoolPlayableCards();
        // console.log(CardsManager.GetLength());
    }

    protected IsOnlyLeftButtonDown(pointer: Phaser.Input.Pointer): boolean {
        // user can still hold LMB pressed while he presses RMB, MMB, FWMB or BKMB
        // (that also need to be filtered out) 
        return (
            pointer.leftButtonDown() &&
            !pointer.middleButtonDown() &&
            !pointer.rightButtonDown() &&
            !pointer.backButtonDown() &&
            !pointer.forwardButtonDown()
        );
    }

    public OnResizeManual(): void {
        // console.log("OnResizeManual");

        // process resize
        const windowRect: RectSize = ScreenManager.GetWindowRect();
        this.OnResize(windowRect);
    }

    private OnResize(windowRect: RectSize): void {
        // console.log("OnResize");
        // console.trace("OnResize");
        // console.log(windowRect.width, windowRect.height);

        const screenOrientationType: ScreenOrientationType = ScreenManager.GetOrientation();
        const assetScale: number = ScreenManager.GetAssetScale();

        const screenCenterX: number = (0.5 * windowRect.width) | 0;
        const screenCenterY: number = (0.5 * windowRect.height) | 0;
        const screenWidth: number = Math.ceil(windowRect.width);

        // quick&dirty fix for need to double resize to correctly position player (on Andorid9 only)
        // this.players.OnResize(windowRect);
        this.players.OnResize(windowRect);
        const northPlayer: Player = this.players.GetPlayerByIndex(0);

        this.majorDeclarationContainer.setPosition(screenCenterX, screenCenterY);

        const btnLobbyScale = ScreenManager.GetAssetScale(
            LayoutDataManager.GetSharedData().general.screen.closeButton.baseScale,
            LayoutDataManager.GetSharedData().general.screen.closeButton.scaleBias,
        );

        const headerProps: LobbyHeaderProps = LayoutDataManager.GetSharedData().lobby.header;
        const btnSpacing: number = headerProps.btnSpacing * btnLobbyScale;
        const btnOffset: number = headerProps.btnOffset * btnLobbyScale;

        // const btnLobbyPosX = btnOffset;
        const btnLobbyPosX = this.scene.scale.isFullscreen && IsIPad() ?
            AppSettings.layout.IPAD_UI_TL_FS_OFFSET_X + btnOffset :
            btnOffset;
        const btnLobbyPosY = btnOffset;
        const btnHintsPosX = screenWidth - btnOffset;
        const btnHintsPosY = btnOffset;
        const btnFsPosX = screenWidth - btnOffset - btnSpacing;
        const btnFsPosY = btnOffset;

        this.btnLobby.setScale(btnLobbyScale);
        this.btnLobby.setPosition(btnLobbyPosX, btnLobbyPosY);
        // console.log(this.scene.scale.isFullscreen, IsIPad());

        this.btnHints.setScale(btnLobbyScale);
        this.btnHints.setPosition(btnHintsPosX, btnHintsPosY);
        if (this.btnFullscreen) {
            this.btnFullscreen.setScale(1.2 * btnLobbyScale);
            this.btnFullscreen.setPosition(btnFsPosX, btnFsPosY);
        }

        this.popupHint.OnResize(windowRect);

        // Position based on orientation (this is good)
        // NOTE: if you need to restructure view based on orientation change, 
        //       its best to not do so through ScreenManagerEvents.RESIZE
        //       but through ScreenManagerEvents.ORIENTATION_CHANGE
        // const lastTrickViewScale: number = ScreenManager.GetAssetScale(0.6, 1.0);
        // const cardPointsViewScale: number = ScreenManager.GetAssetScale(0.6, 1.0);

        let tableScoreScale: number;
        let popupContraBidScale: number;
        let popupContraScale: number;
        let popupChoiceTakeSuitScale: number;
        let popupChoiceChooseSuitScale: number;
        let majorDeclarationContainerScale: number;
        let lastTrickViewScale: number;
        let cardPointsViewScale: number;
        switch (screenOrientationType) {
            case ScreenOrientationType.LANDSCAPE:
                tableScoreScale = ScreenManager.GetAssetScale(0.75, 0.7);
                popupContraBidScale = ScreenManager.GetAssetScale(1.0, 0.8);
                popupContraScale = ScreenManager.GetAssetScale(0.9, 0.8);
                popupChoiceTakeSuitScale = ScreenManager.GetAssetScale(1.0, 1.0);
                // popupChoiceTakeSuitScale = 1 / ScreenManager.GetAssetScale(1.8, 0.75);
                popupChoiceChooseSuitScale = ScreenManager.GetAssetScale(1.0, 0.8);
                majorDeclarationContainerScale = ScreenManager.GetAssetScale(1.0, 1.0);
                lastTrickViewScale = ScreenManager.GetAssetScale(0.7, 1.0);
                cardPointsViewScale = ScreenManager.GetAssetScale(0.7, 1.0);

                // this.popupHint.bubble.SetFacingGrowingLeft(true);
                
                // popupChoiceChooseSuit
                if (this.variationId == VariationId.BELOTE) {
                    this.popupChoiceTakeSuit.scale = popupChoiceTakeSuitScale;
                    this.popupChoiceTakeSuit.setPosition(screenCenterX, screenCenterY - 100 * popupChoiceTakeSuitScale);
                    this.popupChoiceChooseSuit.scale = popupChoiceChooseSuitScale;
                    this.popupChoiceChooseSuit.setPosition(screenCenterX, screenCenterY - 60 * popupChoiceChooseSuitScale);
                }

                // popupContraBid
                else {
                    // Contree and Coinche Bid popup
                    this.popupContraBid.scale = popupContraScale;
                    this.popupContraBid.setPosition(screenCenterX, screenCenterY - 30 * popupContraBidScale);

                    // popupContra:
                    // [      title     ]
                    // [re/contra] [pass]
                    this.popupContra.scale = popupContraScale;
                    this.popupContra.setPosition(screenCenterX, screenCenterY - 100 * popupContraScale);
                }

                const stacksScaleLandscape = ScreenManager.GetAssetScale(0.7, 0.9);
                this.tableStackInit.scale = stacksScaleLandscape;
                this.tableStackPlay.scale = stacksScaleLandscape;
                this.tableStackInit.setPosition(screenCenterX, screenCenterY - 60 * assetScale);
                this.tableStackPlay.setPosition(screenCenterX, screenCenterY - 100 * assetScale);

                if (this.tableScore.IsShowing()) {
                    // this.tableScore.setPosition(
                    //     (this.btnLobby.view.displayWidth + 80) * btnLobbyScale,
                    //     20 * tableScoreScale,
                    // );
                    this.tableScore.setPosition(
                        this.btnLobby.x + btnSpacing * 0.6,
                        20 * tableScoreScale,
                    );
                }
                // either way apply scale, coz trumpView also uses it
                this.tableScore.scale = tableScoreScale;

                // update scoreView and selectedTrumpView (size, layout/snapping) 
                // from screen scale OR visibility change
                this.UpdateScoreAndSelectedTrumpViews();

                if (this.tableScore.IsShowing()) {
                    this.selectedTrumpView.setPosition(
                        this.tableScore.x,
                        this.tableScore.y + (this.tableScore.GetSize().height - 20) * tableScoreScale,
                    );
                }
                else {
                    this.selectedTrumpView.setPosition(
                        // (this.btnLobby.view.displayWidth + 80) * btnLobbyScale,
                        this.btnLobby.x + btnSpacing * 0.6,
                        0,
                    );
                }

                this.lastTrickView.setPosition(0, windowRect.height - 20);
                this.lastTrickView.scale = lastTrickViewScale;
                this.cardPointsView.setPosition(screenWidth, windowRect.height - 20);
                this.cardPointsView.scale = cardPointsViewScale;
                break;

            case ScreenOrientationType.PORTRAIT:
                tableScoreScale = ScreenManager.GetAssetScale(1.0, 0.7);
                popupContraScale = ScreenManager.GetAssetScale(1.1, 0.8);
                popupContraBidScale = ScreenManager.GetAssetScale(1.1, 0.8);
                popupChoiceTakeSuitScale = ScreenManager.GetAssetScale(1.1, 0.8);
                popupChoiceChooseSuitScale = ScreenManager.GetAssetScale(1.1, 0.8);
                majorDeclarationContainerScale = ScreenManager.GetAssetScale(1.9, 1.0);
                lastTrickViewScale = ScreenManager.GetAssetScale(0.8, 0.85);
                cardPointsViewScale = ScreenManager.GetAssetScale(0.8, 0.85);
                
                this.popupHint.bubble.SetFacingGrowingUp(true);

                // popupChoiceChooseSuit
                if (this.variationId == VariationId.BELOTE) {
                    this.popupChoiceTakeSuit.scale = popupChoiceTakeSuitScale;
                    this.popupChoiceTakeSuit.setPosition(screenCenterX, screenCenterY /*- 0 * popupChoiceTakeSuitScale*/);

                    this.popupChoiceChooseSuit.scale = popupChoiceChooseSuitScale;
                    this.popupChoiceChooseSuit.setPosition(screenCenterX, screenCenterY);
                }

                // popupContraBid
                // if (this.variationId != VariationId.BELOTE) {
                else {
                    this.popupContraBid.scale = popupContraBidScale;
                    this.popupContraBid.setPosition(screenCenterX, screenCenterY);

                    this.popupContra.scale = popupContraScale;
                    this.popupContra.setPosition(screenCenterX, screenCenterY);
                }

                const stacksScalePortrait = ScreenManager.GetAssetScale(1.3, 0.95);
                this.tableStackInit.scale = stacksScalePortrait;
                this.tableStackPlay.scale = stacksScalePortrait;
                this.tableStackInit.setPosition(screenCenterX, screenCenterY);
                this.tableStackPlay.setPosition(screenCenterX, screenCenterY);

                // actual or theoretical vertical position of tableScore
                // selectedTrumpView also uses this value for its positioning
                // NOTE: tableScore has its origin TL
                const tableScoreY: number = windowRect.height * 0.15;
                if (this.tableScore.IsShowing()) {
                    this.tableScore.setPosition(
                        screenCenterX - this.tableScore.GetSize().width * 0.5 * tableScoreScale,
                        tableScoreY,
                    );
                }
                // either way apply scale, coz trumpView also uses it
                this.tableScore.scale = tableScoreScale;

                // update scoreView and selectedTrumpView's size, layout/snapping 
                // from screen scale OR visibility change
                this.UpdateScoreAndSelectedTrumpViews();

                if (this.tableScore.IsShowing()) {
                    this.selectedTrumpView.setPosition(
                        this.tableScore.x,
                        tableScoreY + (this.tableScore.GetSize().height - 20) * tableScoreScale,
                    );
                }
                else {
                    this.selectedTrumpView.setPosition(
                        screenCenterX - this.selectedTrumpView.GetSize().width * 0.5 * tableScoreScale,
                        // 350 * northPlayer.cardsContainer.scale,
                        tableScoreY + (this.tableScore.GetSize().height - this.selectedTrumpView.GetSize().height) * 0.5 * tableScoreScale,
                    );
                }
                this.lastTrickView.setPosition(0, 190 * btnLobbyScale);
                this.lastTrickView.scale = lastTrickViewScale;
                this.cardPointsView.setPosition(screenWidth, 190 * btnLobbyScale);
                this.cardPointsView.scale = cardPointsViewScale;
                break;
        }
        
        this.majorDeclarationContainer.scale = majorDeclarationContainerScale;
    }

    private OnOrientationChangedManual(): void {
        const curOrientation: ScreenOrientationType = ScreenManager.GetOrientation();
        this.OnOrientationChanged(curOrientation);
    }

    private OnOrientationChanged(screenOrientationType: ScreenOrientationType): void {
        // console.log("OnOrientationChanged");

        switch (screenOrientationType) {
            case ScreenOrientationType.LANDSCAPE:
                // popupContraBid
                if (this.variationId != VariationId.BELOTE) {
                    this.popupContraBid.SetOrientation(screenOrientationType, true); // updateView?
                }
                break;
            case ScreenOrientationType.PORTRAIT:
                // popupContraBid
                if (this.variationId != VariationId.BELOTE) {
                    this.popupContraBid.SetOrientation(screenOrientationType, true);
                }
                break;
        }
        this.players.OnOrientationChanged(screenOrientationType);
    }

    /**
     * Update selectedTrumpView size due to change in tableScore size
     * Used by:
     * TableScreen::OnResize
     * TableStateMachineBelote:: 'whenever tableScore is updated'
     */
    public UpdateScoreAndSelectedTrumpViews(): void {
        // NOTE: SetLayout triggers UpdateView that uses size for update. 
        //       Set size prior to this or use updateView=false.
        if (this.tableScore.IsShowing()) {
            const tableScoreSize: RectSize = this.tableScore.GetSize();
            const selectedTrumpViewSize: RectSize = new RectSize(tableScoreSize.width, 50);
            this.selectedTrumpView.SetSize(selectedTrumpViewSize);
        }
        // !this.tableScore.IsShowing()
        else {
            const selectedTrumpViewSize: RectSize = new RectSize(400, 50);
            this.selectedTrumpView.SetSize(selectedTrumpViewSize);
        }

        // UPDATE LAYOUTS of both (eg 'snapping')
        // selectedTrumpView visibility just updated.
        // refresh tableScore and cardPointsView snapping/Layout
        if (this.tableScore.IsShowing()) {
            if (this.selectedTrumpView.IsShowing()) {
                this.tableScore.SetLayout(TableScoreLayout.SNAP_BOTTOM, true);
                this.selectedTrumpView.SetLayout(SelectedTrumpViewLayout.SNAP_TOP, true);
            }
            else {
                this.tableScore.SetLayout(TableScoreLayout.ROUNDED, true);
                // this.selectedTrumpView.SetLayout(SelectedTrumpViewLayout.ROUNDED, true);
            }
        }
        // !this.tableScore.IsShowing()
        else {
            if (this.selectedTrumpView.IsShowing()) {
                this.selectedTrumpView.SetLayout(SelectedTrumpViewLayout.ROUNDED, true);
            }
            // else {
            //     this.selectedTrumpView.SetLayout(SelectedTrumpViewLayout.ROUNDED, true);
            // }
        }

        // Addendum: and scale
        this.selectedTrumpView.scale = this.tableScore.scale;
    }

    // public AreMajorDeclarationsSupported(): boolean {
    //     return this.variationId != VariationId.CONTREE;
    // }
}